import type { MarkerFeature } from "../../../../../utils/models/MarkerFeature";
import type { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import type { UndoCommand, CommandContext } from "../types";

type RouteSnapshot = {
  markers: MarkerFeature[];
  lineStrings: LineStringFeature[];
};

export class DeleteSelectedMarkersCommand implements UndoCommand {
  readonly type = 'DELETE_SELECTED_MARKERS';
  readonly routeKey: string | null;

  private routesBefore: Record<string, RouteSnapshot>;
  private routesAfter: Record<string, RouteSnapshot>;

  constructor(data: {
    routesBefore: Record<string, RouteSnapshot>;
    routesAfter: Record<string, RouteSnapshot>;
  }) {
    this.routesBefore = JSON.parse(JSON.stringify(data.routesBefore));
    this.routesAfter = JSON.parse(JSON.stringify(data.routesAfter));
    const keys = Object.keys(data.routesBefore);
    this.routeKey = keys.length === 1 ? keys[0] : null;
  }

  undo(ctx: CommandContext): void {
    for (const [routeKey, snapshot] of Object.entries(this.routesBefore)) {
      const route = ctx.state.routes[routeKey];
      if (!route) continue;
      route.markers = JSON.parse(JSON.stringify(snapshot.markers));
      route.lineStrings = JSON.parse(JSON.stringify(snapshot.lineStrings));
      route.updated_at = new Date();
    }
  }

  redo(ctx: CommandContext): void {
    for (const [routeKey, snapshot] of Object.entries(this.routesAfter)) {
      const route = ctx.state.routes[routeKey];
      if (!route) continue;
      route.markers = JSON.parse(JSON.stringify(snapshot.markers));
      route.lineStrings = JSON.parse(JSON.stringify(snapshot.lineStrings));
      route.updated_at = new Date();
    }
  }
}
